class employeeMapper {
	toDomain(persistence) {
		return {
			id: persistence.id,
			name: persistence.name,
			area: persistence.employeeArea.area,
			//area: language === 'pt' ? persistence.employeeArea.area_brasil : persistence.employeeArea.area,
		}
	}
}

export default new employeeMapper()
